





























import { Component, Vue, Prop } from 'vue-property-decorator';
import {
    bookingProgression,
    bookingProgressionColors,
} from '@/data/bookingProgression';

const DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

@Component({})
export default class BookingStatus extends Vue {
    @Prop() status!: string | undefined;

    get bookingProgressionArr() {
        return Object.keys(bookingProgression).map(key => ({
            text: (bookingProgression as any)[key],
            value: key,
            color: (bookingProgressionColors as any)[key],
        }));
    }

    get statusIndex() {
        return this.bookingProgressionArr.findIndex(
            el => el.value === this.status
        );
    }

    onStatus(value: string) {
        if (DEV) {
            this.$emit('status', value);
        }
    }
}
